import React from "react";
import { createRoot } from "react-dom/client";
import { ApplicationErrorBoundary } from "./components/ApplicationErrorBoundary";
import { Toaster } from "./shared/ui/sonner";
import AppRoot from "./AppRoot";
import "./styles/globals.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Application root element is missing.");
const root = createRoot(rootElement);
root.render(
  <ApplicationErrorBoundary>
    <AppRoot />
    <Toaster />
  </ApplicationErrorBoundary>,
);
